import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StorageHandler from 'config/StorageHandler';
import { social, storageKeys } from 'config/settings.json';

const Icon = (props) => {
  const { href, icon, size } = props;
  const platformName = icon
    .split(' ')
    .pop()
    .replace(/-/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());
  return (
    <a
      style={{ fontSize: !Number.isNaN(+size) ? `${size}rem` : size }}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="icons"
      aria-label={platformName}
    >
      <FontAwesomeIcon icon={icon.replace('twitter', 'x-twitter').split(' ')} />
    </a>
  );
};

const SocialIcons = (props) => {
  const { size, customIcons } = props;
  const [socials, setSocials] = useState(null);
  const [filteredSocials, setFilteredSocials] = useState(null);

  const getSocials = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setSocials(appInfo.socials);
    }
  };

  const setSocialIcons = () => {
    const filteredSocialObject = {};
    if (socials) {
      Object.keys(customIcons).forEach((icon) => {
        if (Object.prototype.hasOwnProperty.call(social, icon) && social[icon] && social[icon].length > 0) {
          filteredSocialObject[icon] = {
            icon: customIcons[icon],
            href: social[icon],
          };
        }
      });

      Object.keys(socials).forEach((name) => {
        if (
          Object.prototype.hasOwnProperty.call(socials, name) &&
          socials[name] &&
          socials[name].length > 0 &&
          !Object.prototype.hasOwnProperty.call(filteredSocialObject, name)
        ) {
          filteredSocialObject[`fab ${name.toLowerCase()}`] = socials[name];
        }
      });

      setFilteredSocials(filteredSocialObject);
    }
  };

  useEffect(() => {
    getSocials();
    setSocialIcons();
  }, [socials]);

  let icons;
  if (filteredSocials) {
    icons = Object.keys(filteredSocials).map((name) => (
      <Icon
        key={name}
        href={filteredSocials[name].href || filteredSocials[name]}
        icon={filteredSocials[name].icon || name}
        size={size}
      />
    ));
  }

  return <div className="socialIcons">{icons}</div>;
};

export default SocialIcons;

SocialIcons.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customIcons: PropTypes.shape(),
};

SocialIcons.defaultProps = {
  size: 'inherit',
  customIcons: {},
};

Icon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Icon.defaultProps = {
  size: 'inherit',
};
